import { addThousandsSeparator } from "@root/util/number";
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { HouseStatusService } from "@root/router/deprecated_and_do_not_use-house/house-status/house-status.service";
import { PlatformType } from "@root/config";
import { NzModalService } from "ng-zorro-antd/modal";
import { NzMessageService } from "ng-zorro-antd/message";
import * as moment from "moment";
import _, { head, last } from "lodash";
import { CtripPriceFormService } from "../../operate-sidebar/ctrip-price-form/ctrip-price-form.service";
import { CmpModalPriceDescService } from "@root/router/price/cmp-modal-price-desc/cmp-modal-price-desc.service";
import { TranslateService } from "@root/shared/service/translate.service";
import { WritePermissionGurd } from "@root/util/decorator";
import { DateService } from "@root/shared/service/date.service";
import { AppService } from "@root/app.service";
import { ModalService } from "@root/router/index/modal.service";
import { HttpClient } from "@angular/common/http";
import { forkJoin } from "rxjs";
import { BridgeService } from "../bridge.service";
import {
  MultiHouseCalendarService,
  PriceChild,
} from "../../calendar/multi-house-calendar/multi-house-calendar.service";

interface PriceRange {
  // thirdparty_type: number;
  // currency_type: string;
  min: number;
  max: number;
  price: number;
  placeholder?: string;
  limit?: {
    currency: string;
    min: number;
    max: number;
  };
  checking?: boolean;
}
enum HouseType {
  House = 0,
  Type = 1,
}

interface Price {
  price: number;
  max: number;
  min: number;
  [props: string]: any;
}

interface DataItem {
  house_info: PriceChild;
  thirdparty_type: PlatformType;
  payment_type: number;

  price: number;
  max: number;
  min: number;
  [props: string]: any;
}

// type PriceChild = Child & {
//   thirdparty_type: number;
// };

@Component({
  selector: "host-house-price",
  templateUrl: "./house-price.component.html",
  styleUrls: ["./house-price.component.scss"],
})
export class HousePriceComponent implements OnInit {
  // @Input() id;
  @Input() dateRange: Array<string | Date> = [];
  // @Input() nights;
  @Input() entity: PriceChild;

  @Input() set listOfCalendar(value) {
    this.updatePriceRange(value);
  }

  @Input() listOfForbiddenDates = [];
  @Output() success = new EventEmitter();

  get houseType(): HouseType {
    return this.entity?.c_parent?.p_type;
    // return this.relatedHouse && this.relatedHouse.type;
    // return _.get(this.entity, 'related.type');
  }

  get nights() {
    const h = moment(_.head(this.dateRange));
    const l = moment(_.last(this.dateRange));
    return l.diff(h, "days") + 1;
  }

  nzFormat = this.dateService.getAngularFormat(["YMD"]);
  listOfPrice: Array<PriceRange> = [];
  listOfDataByThirdparty: DataItem[] = [];
  listOfChannelRatio = [];
  ctripCommissionRate = 10;
  // hasCtrip = false;

  //#region Price Mode
  priceMode: "edit" | "copy" = "edit";
  optionsOfCopySource: Option[] = [];
  copySource: number;
  //#endregion
  _price; // 一键改价
  get price() {
    return this._price;
  }

  set price(val) {
    this._price = val;

    /**
     *  过滤掉依赖的价格渠道
     */
    this.listOfDataByThirdparty
      .filter((item) => !item.house_info.c_readonly)
      .forEach((item) => {
        item.price = this.calculateChannelRatioPrice(item.listing_pricing_ratio, this.price);

        if (this.isCtrip(item.thirdparty_type)) {
          this.recalculateCtripPrice(item);
        }
      });
  }

  get hasCtrip() {
    return _.find(this.listOfDataByThirdparty, (item) => this.isCtrip(item.thirdparty_type));
  }

  get hasBooking() {
    return _.find(this.listOfDataByThirdparty, (item) => this.isBooking(item.thirdparty_type));
  }

  get displayThousandsSep() {
    return this.bridge.displayThousandsSep;
  }

  get isInternational() {
    return this.app.app.international;
  }

  disabledDate = (date: string | Date) => {
    const head = moment().subtract(1, "d");
    const last = moment().add(2, "year");

    return !moment(date).isBetween(head, last, "d");
  };
  constructor(
    private httpService: HouseStatusService,
    private messageService: NzMessageService,
    private houseCalendarService: MultiHouseCalendarService,
    private modalService: NzModalService,
    private ctripPriceFormService: CtripPriceFormService,
    private modalPriceService: CmpModalPriceDescService,
    private translate: TranslateService,
    private dateService: DateService,
    private app: AppService,
    private modal: ModalService,
    private http: HttpClient,
    private bridge: BridgeService,
  ) {}

  ngOnInit() {
    this.requestCtripCommissionRate();
    this.fetchChannelPriceRatio();
  }

  private fetchChannelPriceRatio() {
    forkJoin([
      this.http.get("/api/setting/channel_price_ratio"),
      this.http.get("/api/thirdparty/had_thirdparty"),
    ]).subscribe((rst: any) => {
      const allChannels = rst[0]?.data?.list ?? [];
      const hadChannels = rst[1]?.data?.had_thirdparty ?? [];
      this.listOfChannelRatio = allChannels.filter((c) => hadChannels.includes(c.thirdparty_type));
      console.log("list of channel: ", this.listOfChannelRatio);
    });
  }

  private hasDisabledBetween(begin, end) {
    return _.some(
      this.listOfForbiddenDates,
      (date) => moment(date).isSameOrBefore(end) && moment(date).isSameOrAfter(begin),
    );
  }

  updatePriceRange(keys: Array<any> = []) {
    console.log("update price range: ", keys);
    const list = _.map(keys, (_key) => {
      //#region 添加对应渠道的房源信息

      // const houseInfo = this.relatedHouse.related.p_children.find((house) => house.unique_key === currentKey);
      const entity = _key.house_info as PriceChild;
      const key = { ..._key };
      //#endregion
      const calendar = key.calendar;

      const currentThirdparty = this.entity.thirdparty_type;
      const currentUniqueKey = this.entity.c_id;

      let price = null;
      let placeholder = "";

      const orderByPrice = _.orderBy(calendar, ["price"]);
      const min = _.head(orderByPrice).price;
      const max = _.last(orderByPrice).price;
      price = min === max ? min : null;
      placeholder = min === max ? "" : `${min}-${max}`;

      /**
       * 每天的价格一致
       * 只需要高亮显示当前房源的价格，其他房源的价格以placeholder的方式显示
       *
       * 每天价格不一致的情况不需处理，因为price = null，会显示placeholder
       * */
      if (price !== null) {
        if (key.thirdparty_type !== currentThirdparty || key.unique_key !== currentUniqueKey) {
          placeholder = price;
          price = null;
        }
      }

      /**
       * rate plan 的价格不可编辑
       */
      if (entity.c_readonly) {
        placeholder = "N/A";
        price = null;
      }

      key.min = min;
      key.max = max;

      key.price = price;
      key.placeholder = placeholder;

      if (this.isCtrip(key.thirdparty_type)) {
        const orderByReservePrice = _.orderBy(calendar, ["reserve_price"]);
        const minReservePrice = _.head(orderByReservePrice);
        const maxReservePrice = _.last(orderByReservePrice);

        key.max_reserve_price = maxReservePrice.reserve_price;
        key.min_reserve_price = minReservePrice.reserve_price;

        const item = minReservePrice;
        key.price = null; /** 携程不显示任何值，所以全部置空 */
        key.placeholder = "";

        /** 初始值 */
        key.init_commission_rate = item.commission_rate;
        key.init_reserve_price = item.reserve_price;
        key.init_sale_price = item.sale_price;

        key.commission_rate = item.commission_rate;
        key.reserve_price = item.reserve_price;
        key.sale_price = item.sale_price;

        key.displayCtripPriceForm = false;

        // this.hasCtrip = true;
      }

      /**
       * copy 模式下，自动选中 checkbox，依赖 rateplan 的房源除外
       */
      if (key.house_info.c_readonly) {
        key.checked = false;
      } else {
        key.checked = true;
      }

      return key;
    });
    this.listOfDataByThirdparty = list;
    this.optionsOfCopySource = this.listOfDataByThirdparty
      .filter((item) => !item.house_info.c_readonly)
      .map((item) => ({
        label: item.house_info.c_title,
        value: item.house_info.c_id,
      }));
    this.copySource = this.optionsOfCopySource?.[0]?.value;
    console.log("[house price listOfDataByThridparty]", list);
  }

  changeDate(value) {
    const head = moment(_.head(value));
    const last = moment(_.last(value));

    /** 检查选择的日期之间是否有订单 */
    while (this.hasDisabledBetween(head, last)) {
      last.subtract(1, "d");
    }

    this.dateRange = [head.toDate(), last.toDate()];
  }

  // checkAllPrices() {
  //   _.forEach(this.listOfDataByThirdparty, (item) => (item.checking = true));
  // }

  // checkDateIsInRange() {
  //   const end = _.last(this.dateRange);
  //   const endLimit = moment().add(6, "month");

  //   if (endLimit.isAfter(end, "d")) {
  //     return true;
  //   }
  //   // 仅可操作7个月内的日期
  //   const warningText = this.translate.syncGet("warning.available_within_seven_months");
  //   this.messageService.info(warningText);
  //   return false;
  // }

  private requestUpdatePrice() {
    console.log("this.entity: ", this.entity);
    const edit_type = "house_price";
    const version = "2.4";
    const type = this.houseType;

    // const relation_id = _.get(this.entity, 'related.relation_id');
    const relation_id = this.entity.c_parent.p_id;
    const thirdparty_list = _.map(
      _.filter(this.listOfDataByThirdparty, (p) => p.price !== null),
      (item) => {
        if (this.isCtrip(item.thirdparty_type)) {
          return {
            unique_key: item.unique_key,
            reserve_price: item.reserve_price,
            sale_price: item.sale_price,
            commission_rate: item.commission_rate,
            payment_type: item.payment_type,
            type: "sale_price",
          };
        } else {
          return { unique_key: item.unique_key, price: item.price };
        }
      },
    );
    const begin = moment(_.head(this.dateRange)).format("YYYY-MM-DD");
    const end = moment(_.last(this.dateRange)).format("YYYY-MM-DD");
    const params = {
      version,
      relation_id,
      type,
      edit_type,
      begin,
      end,
      thirdparty_list: JSON.stringify(thirdparty_list),
    };
    this.httpService.updatePriceOrStock(params).subscribe((res) => {
      if (res && res.error_code === 0) {
        this.refreshCalendar();
        this.success.emit();
      }
    });
  }

  private requestCopyPrice() {
    console.log("this.list of data by thirdpatty: ", this.listOfDataByThirdparty);
    const from = this.copySource;
    const to = this.listOfDataByThirdparty
      .filter((item) => item.checked && item.house_info.c_id !== this.copySource)
      .map((item) => item.house_info.c_id);
    const start = moment(head(this.dateRange)).format("YYYY-MM-DD");
    const end = moment(last(this.dateRange)).format("YYYY-MM-DD");
    const params = {
      from,
      to,
      start,
      end,
    };

    this.httpService.requestCopyPriceTo(params).subscribe((rst: any) => {
      if (rst?.error_code === 0) {
        this.refreshCalendar();
        this.success.emit();
      }
    });
  }

  private requestCtripCommissionRate() {
    this.httpService.getCtripCommissionRate().subscribe((res) => {
      console.log("ctrip commission rate: ", res);
      this.ctripCommissionRate = (_.get(res, "data.min") || 0.1) * 100;
    });
  }

  refreshCalendar() {
    this.houseCalendarService.calendarRefreshRaw$.next(null);
  }

  @WritePermissionGurd("rate")
  onClickSave() {
    // if (!this.checkDateIsInRange()) {
    //   return;
    // }

    console.log("this.listOfDATAbYtHIRDPATY: ", this.listOfDataByThirdparty);

    if (this.priceMode === "copy") {
      this.requestCopyPrice();
      return;
    }

    const largeDiff = this.hasLargeDiffPrice(this.listOfDataByThirdparty);
    if (largeDiff) {
      this.displayPriceConfirmModal().then(() => {
        this.requestUpdatePrice();
      });
    } else {
      this.requestUpdatePrice();
    }
  }

  onClickCancel() {
    this.success.emit();
  }

  // hasWritePermission() {
  //   return this.authorityService.hasWritePermission("calendar");
  // }

  // /** @deprecated */
  // onClearCtripPriceForm(form) {
  //   form.price = null;
  //   form.placeholder = "";

  //   form.reserve_price = form.init_reserve_price;
  //   form.sale_price = null;

  //   form.displayCtripPriceForm = false;
  // }

  // /** @deprecated */
  // onConfirmCtripPriceForm(form, data) {
  //   console.log("form: ", form);
  //   console.log("data: ", data);

  //   form.commission_rate = data.commission / 100;
  //   form.sale_price = data.salePrice;
  //   form.reserve_price = data.reservePrice;
  //   form.price = data.salePrice;

  //   form.displayCtripPriceForm = false;
  // }

  onDisplayListingPr() {
    console.log("entity: ", this.entity);
    if (this.entity.house_type_price_id) {
      this.modal.displayRoomTypeDetailDrawer(this.entity.c_parent.p_id, 2);
    } else {
      this.modal.displayPropertyDetailDrawer(this.entity.c_parent.p_id, 2);
    }
  }

  displayPriceDescModal() {
    this.modalPriceService.displayPriceModal();
  }

  displayPriceConfirmModal() {
    return new Promise((resolve, reject) => {
      this.modalService.confirm({
        nzTitle: this.translate.t("operate-sidebar_house-price_ts_价格差距过大"),
        nzOnOk: () => {
          resolve(null);
        },
      });
    });
  }

  isCtrip(thirdparty) {
    return +thirdparty === PlatformType.Ctrip;
  }

  isBooking(thirdparty) {
    return +thirdparty === PlatformType.Booking;
  }

  // ctripReservePriceText(data) {
  //   if (_.isNil(data.price)) {
  //     return data.max_reserve_price === data.min_reserve_price
  //       ? data.min_reserve_price
  //       : `${data.min_reserve_price}~${data.max_reserve_price}`;
  //   }

  //   return data.reserve_price;
  // }

  recalculateCtripPrice(data) {
    data.reserve_price = this.calculateReservePrice(data.commission_rate * 100, data.price);
    data.sale_price = data.price;
  }

  private calculateChannelRatioPrice(ratio, price) {
    // const item = this.listOfChannelRatio.find((c) => c.thirdparty_type === channel);
    return (price * (ratio ?? 100)) / 100;
  }

  private hasLargeDiffPrice(prices: DataItem[]) {
    const list = prices.filter((p) => p.price);

    if (_.isEmpty(list)) {
      return false;
    }
    const max = _.maxBy(list, (p) => p.max).max;
    const min = _.minBy(list, (p) => p.min).min;
    console.log("max: ", max, " min: ", min);
    return list.some((price) => price.price > max * 5 || price.price < min * 0.2);
  }

  // private calculateSalePrice(commission, reservePrice) {
  //   return this.ctripPriceFormService.calculateSalePrice(commission, reservePrice);
  // }

  private calculateReservePrice(commission, salePrice) {
    return this.ctripPriceFormService.calculateReservePrice(commission, salePrice);
  }
}
